import { useState } from "react";
import * as Sentry from "@sentry/react";
import { getSessionId } from "@britishcouncil/react-common";
import { useAppSettings } from "settings";

export const useSentry = () => {
  const {
    sentry: { environment, release },
  } = useAppSettings();
  const [isInitialized, setIsInitialized] = useState(false);

  if (import.meta.env.PROD && !isInitialized) {
    Sentry.init({
      dsn: "https://92f38d369aeef8bf00bb5c8ff392d986@o505679.ingest.us.sentry.io/4509531543044096",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      ],
      sendDefaultPii: true,
      tracesSampleRate: 1.0,
      environment,
      release,
      enableLogs: true,
    });

    Sentry.setTags({
      sessionId: getSessionId(),
    });

    setIsInitialized(true);
  }
};
